const COLOR_MAP = {
  amarillo: "#f7d717",
  azul: "#467ab7",
  blanco: "#ffffff",
  naranja: "#f9882f",
  negro: "#000000",
  purpura: "#7066b5",
  rojo: "#d13a30",
};

export const MARCO_MOSAICO_COLORS = [
  "amarillo",
  "azul",
  "blanco",
  "naranja",
  "negro",
  "purpura",
  "rojo",
].map((color) => ({
  id: color,
  name: color.charAt(0).toUpperCase() + color.slice(1),
  swatch: COLOR_MAP[color],
  frameSrc: `/images/frames-marco/marco-mosaico/marco-mosaico-${color}.png`,
}));

export const MARCO_MOSAICO_CONFIG = {
  id: "marco-mosaico",
  name: "Marco Mosaico",
  canvas: {
    w: 900,
    h: 900,
  },
  photoBoxes: [
    {
      id: "topLeft",
      label: "Foto superior izquierda",
      shortLabel: "Superior izquierda",
      x: 115,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "topRight",
      label: "Foto superior derecha",
      shortLabel: "Superior derecha",
      x: 480,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "bottomLeft",
      label: "Foto inferior izquierda",
      shortLabel: "Inferior izquierda",
      x: 116,
      y: 485,
      w: 306,
      h: 306,
    },
    {
      id: "bottomRight",
      label: "Foto inferior derecha",
      shortLabel: "Inferior derecha",
      x: 480,
      y: 485,
      w: 306,
      h: 306,
    },
  ],
  mobilePhotoBoxes: [
    {
      id: "topLeft",
      label: "Foto superior izquierda",
      shortLabel: "Superior izquierda",
      x: 115,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "topRight",
      label: "Foto superior derecha",
      shortLabel: "Superior derecha",
      x: 480,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "bottomLeft",
      label: "Foto inferior izquierda",
      shortLabel: "Inferior izquierda",
      x: 116,
      y: 485,
      w: 306,
      h: 306,
    },
    {
      id: "bottomRight",
      label: "Foto inferior derecha",
      shortLabel: "Inferior derecha",
      x: 480,
      y: 485,
      w: 306,
      h: 306,
    },
  ],
  imageBoxes: [
    {
      id: "topLeft",
      label: "Foto superior izquierda",
      shortLabel: "Superior izquierda",
      x: 115,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "topRight",
      label: "Foto superior derecha",
      shortLabel: "Superior derecha",
      x: 480,
      y: 118,
      w: 306,
      h: 306,
    },
    {
      id: "bottomLeft",
      label: "Foto inferior izquierda",
      shortLabel: "Inferior izquierda",
      x: 116,
      y: 485,
      w: 306,
      h: 306,
    },
    {
      id: "bottomRight",
      label: "Foto inferior derecha",
      shortLabel: "Inferior derecha",
      x: 480,
      y: 485,
      w: 306,
      h: 306,
    },
  ],
};
